import type { SerializeFrom } from '@remix-run/node';
import type { loader } from '../root';

export function getSiteStructuredData(data?: SerializeFrom<typeof loader>) {
	if (!data) return {};
	return {
		'script:ld+json': {
			'@context': 'https://schema.org',
			'@type': 'WebSite',
			'@id': data.webDomain + '/#website',
			url: data.webDomain,
			name: 'The Print Bar',
			publisher: {
				'@id': data.webDomain + '/#organization',
			},
			inLanguage: 'en-AU',
			potentialAction: {
				'@type': 'SearchAction',
				target: {
					'@type': 'EntryPoint',
					urlTemplate: `${data.webDomain}/products?search={search_term_string}`,
				},
				'query-input': 'required name=search_term_string',
			},
		},
	};
}
